import { atom } from 'recoil';
import BeaconFilterItemRequest from '../models/BeaconFilterItemRequest';

const stateFilterImgDisease = atom({
  key: 'filter.img.disease',
  default: null as BeaconFilterItemRequest | null,
});

export default stateFilterImgDisease;
